import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "@mui/material";
import {TailwindModal} from "../src/components";

const SaudatthiPassword = "Rajneethi@365";
const SESSION_STORAGE_KEY = "jagiroadDashboardAuthenticated";

export default function SaudatthiDashboard() {
    const navigate = useNavigate();
    const [authenticated, setAuthenticated] = useState<boolean>(() => {
        if (typeof window === "undefined") return false;
        return sessionStorage.getItem(SESSION_STORAGE_KEY) === "true";
    });
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        if (authenticated) {
            sessionStorage.setItem(SESSION_STORAGE_KEY, "true");
        }
    }, [authenticated]);
    sessionStorage.clear();
    // useEffect(() => {
    //     sessionStorage.removeItem(SESSION_STORAGE_KEY);
    // }, []);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        setError("");
        if (password === SaudatthiPassword) {
            setAuthenticated(true);
        } else {
            setError("Incorrect password. Please try again.");
        }
    };

    const handleCancel = () => {
        navigate("/");
    };

    if (authenticated) {
        return (
            <iframe
                title="Jagiroad"
                src="/Saudatti-yellamma-insights.html"
                className="w-full border-0"
                style={{ height: "calc(100vh - 70px)" }}
            />
        );
    }

    return (
        <TailwindModal isOpen>
            <div className="mx-auto max-w-md rounded-xl bg-white p-6 shadow-xl">
                <h2 className="mb-4 text-[18px] font-semibold text-gray-900">
                    Enter password to view Jagiroad Dashboard
                </h2>
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Password"
                            className="w-full rounded-lg border border-gray-300 px-3 py-2 text-[14px] outline-none focus:border-[#7aa2ff] focus:ring-1 focus:ring-[#7aa2ff]"
                            autoFocus
                        />
                        {error ? (
                            <p className="mt-1 text-[13px] text-red-600">
                                {error}
                            </p>
                        ) : null}
                    </div>
                    <div className="flex justify-end gap-2">
                        <Button
                            type="button"
                            variant="outlined"
                            onClick={handleCancel}
                            className="normal-case"
                        >
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            className="normal-case"
                        >
                            Submit
                        </Button>
                    </div>
                </form>
            </div>
        </TailwindModal>
    );
}
